import { takeEvery } from 'redux-saga/effects'

const takes = ({ sagas, types }) => ([
    takeEvery(types.GET_ACCOUNT_INFO, sagas.getAccountInfo),
    // removed pre launch -RC
    // takeLatest(types.GET_ACCESS, sagas.getAccess)
])

export default takes
